export const errorMessages = {
  require: <div className="error">This field is required.</div>,
};

export const countryCodeIds = {
  US: 230,
  UK: 76,
  GB: 76,
  CA: 38,
};

export const countryNameCodes = {
  UNITED_STATES: 'US',
  UNITED_KINGDOM: 'UK',
  GREAT_BRITAIN: 'GB',
  CANADA: 'CA',
};

export const countryCodesName = {
  US: 'United States',
  UK: 'United Kingdom',
  GB: 'Great Britain',
  CA: 'Canada',
};

export const addressStatus = {
  DELIVERABLE_STATUS: 'deliverable',
  UNDELIVERABLE_STATUS: 'undeliverable',
  NO_MATCH_STATUS: 'no_match',
  MISSING_UNIT_STATUS: 'deliverable_missing_unit',
  MISSING_INFO_STATUS: 'deliverable_missing_info',
  INCORRECT_UNIT_STATUS: 'deliverable_incorrect_unit',
  UNNECESSARY_UNIT_STATUS: 'deliverable_unnecessary_unit',
};

export const addressSuggestionStatus = {
  NO_SUGGESTION: 'no_suggestion',
  SUGGESTION_AVAILABLE: 'suggestion_available',
  VERIFIED: 'verified',
};

const PLEASE_EDIT_MSG = 'Please edit your address.';
const CHOOSE_OPTION_MSG = 'Please choose one of the options below.';

export const addressMessages = {
  UNDELIVERABLE_MSG: {
    firstLine: "The shipping address couldn't be verified as deliverable.",
    secondLine: PLEASE_EDIT_MSG,
  },
  DELIVERABLE_MISSING_UNIT_MSG: {
    firstLine:
      "The shipping address couldn't be verified as deliverable due to a missing unit number.",
    secondLine: PLEASE_EDIT_MSG,
  },
  DELIVERABLE_UNNECESSARY_UNIT_MSG: {
    firstLine:
      "The shipping address couldn't be verified as deliverable due to unnecessary unit info.",
    secondLine: PLEASE_EDIT_MSG,
  },
  DELIVERABLE_INCORRECT_UNIT_MSG: {
    firstLine:
      "The shipping address couldn't be verified as deliverable due to incorrect unit info.",
    secondLine: PLEASE_EDIT_MSG,
  },
  SUBTITLE_OPTIONS: {
    firstLine: "The shipping address couldn't be verified as deliverable.",
    secondLine: CHOOSE_OPTION_MSG,
  },
  SUBTITLE_NO_OPTIONS: {
    firstLine: "The shipping address couldn't be verified as deliverable.",
    secondLine: CHOOSE_OPTION_MSG,
  },
  SUGGESTION_TEXT: 'We have highlighted our suggestions in green.',
};
